import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import moment from 'moment';
import { cbProviderAlert } from '../general-service/cbProviderAlert';
import * as _ from "lodash";


@Injectable()
export class UtilGeneralProvider {

  constructor(public http: HttpClient, public cbAlert: cbProviderAlert) {
    console.log('Hello UtilGeneralProvider Provider');
  }

}

export function GetProductPrice(pSource:any, pProductID, pAccountID): any {
  var returnList = _.filter(pSource, function (o) {
      if (pAccountID <= 0 || !pAccountID)
        return (o.PRODUCT_ID == pProductID && o.PRICE_TYPE == 'NORMAL_PRICE');
      else 
        return (o.PRODUCT_ID == pProductID && o.ACCOUNT_ID == '2127');
    })
    
  
  return returnList;
}


export function GetLodashArrayByKey(pSource:any, pKey:string): any {
  var returnList = _.filter(pSource, function (o) {
    return o.CATEGORY_CODE == pKey;    
    })
    
  
  return returnList;
}


export function FormatDataTableNumber(datasource): any {
  if (typeof datasource == 'undefined')
    return datasource;
  for (var i = 0; i < datasource.length; i++) {
    Object.keys(datasource[i]).forEach(function (key) {
      var valueField = datasource[i][key];

      valueField = NumberWithComma(valueField);
    });
  }
  return datasource;
}

export function NumberWithComma(x): any {
  try {
    if (x == null || typeof x == 'undefined')
      return "";
    x = x.toString();
    var pattern = /(-?\d+)(\d{3})/;
    while (pattern.test(x))
      x = x.replace(pattern, "$1,$2");
    return x;
  } catch (error) {
    return x;
  }

}

export function TranslateToVietnamese(keyField: any): any {
  //console.log(keyField);
  switch (keyField) {
    case "Account Name":
      return "Tên chủ hàng";
      break;
    case "End Client Name":
      return "Khách hàng cuối";
      break;
    case "Delivery Address":
      return "ĐC giao hàng";
      break;
    case "Pickup Address":
      return "ĐC nhận hàng";
      break;
    case "Payment Method":
      return "PT Thanh toán";
      break;
    case "Shipping Request Total":
      return "Giá trị đơn hàng ";
      break;
    case "Cod":
      return "Phí COD";
      break;
    case "Insurance":
      return "Phí bảo hiểm ";
      break;
    case "Delivery At Place":
      return "Giao tại ";
      break;
    case "Receive At Place":
      return "Nhận tại";
      break;
    case "Zone":
      return "Khu vực";
      break;
    case "Region":
      return "Vùng";
      break;
    case "Desciption":
      return "Mô tả thêm";
      break;
    case "Total Shipping Rates":
      return "Tổng phí vận chuyển";
      break;
    case "Basic Rate":
      return "Phí cơ bản";
      break;

    case "Cod Rate":
      return "Phí COD";
      break;
    case "Debit Rate":
      return "Phí thu công nợ ";
      break;
    case "Zone Rate":
      return "Phụ phí khu vực";
      break;
    case "Region Rate":
      return "Phụ phí vùng";
      break;

    case "Over Size Rate":
      return "Phí quá kích cỡ";
      break;
    case "Over Weight Rate":
      return "Phí quá trọng lượng";
      break;
    case "Insurance Rate":
      return "Phí bảo hiểm";
      break;
    case "Receive Rate":
      return "Phí nhận tận nơi";
      break;
    case "Delivery Rate":
      return "Phí giao tận nơi";
      break;
    case "Request Status":
      return "Trạng thái yêu cầu";
      break;
    case "Created By":
      return "Được tạo bởi";
      break;
    case "Related Order Id":
      return "Mã Order";
      break;
    case "Shipping Request Id":
      return "Mã đơn hàng ";
      break;
    case "Plan Delivery Date":
      return "Ngày dự định giao";
      break;
    case "Account Id":
      return "Mã chủ hàng";
      break;
    case "End Client Id":
      return "Mã khách hàng cuối";
      break;
    case "Current Address":
      return "Vị trí đơn hàng";
      break;
    case "Staff Name":
      return "NV bán hàng";
      break;
    case "Staff Phone":
      return "SĐT liên hệ";
      break;
    default:
      return keyField;

  }


  return keyField;
}
export function ToTitleCase(str) {
  return str.replace(/\w\S*/g, function (pText) {
    return pText.charAt(0).toUpperCase() + pText.substr(1).toLowerCase();
  });
}

export function PaymenTypeToColor(val) {
  if (val === "TM") {
    return "#ffaaaa";
  } else if (val == "CN") {
    return "#aaaaff";
  } else {
    return "#aaffaa";
  }
}

export function DebCollectDateToColor(val) {
  if (val < moment.now()) {
    return "#ffaaaa"; 
  } else {


    return "#aaaaff";
  }
}


export function AGCellReDisplayStringValue(params) {
  let val = params.value;
  switch (val) {
    case "COMPLETED":
      return "Hoàn thành";
      break;
    case "DELIVERED":
      return "Đã giao";
      break;
    case "PICKED":
      return "Nhận từ chủ";
      break;
    case "DROPPED_TO_COLLECTION_POINT":
      return "Điểm trung chuyển";
      break;
    case "PICK_FROM_ORIGINAL":
      return "Nhận từ chủ";
      break;
    case "MOVE_NEXT_COLLECTION_POINT":
      return "Đang lưu chuyển";
      break;
    case "DELIVER_TO_END_ADDRESS":
      return "Giao điểm cuối";
      break;
    case "PICKED_FROM_COLLECTION_POINT":
      return "Đã lấy hàng";
      break;
    case "DEBIT_COLLECT_SERVICE":
      return "Thu công nợ";
      break;

    default:
      return "UNKNOWN";
      return val;
  }
};

export function AGGetDefaultColDef() {
  return {
    //checkboxSelection: true,
    sortable: true,
    filter: true,
    headerHeight: 48,
    enableFilter: true,
    resizeable: true
  };

};

export function AGCellDateFormatter(params) {
  return moment(params.value).format('DD/MM HH:mm');
}

export function AGCellCurrencyFormatter(params) {
  return formatNumber(params.value) + ' Đ';
}

export function numberValueParser(params) {
  return Number(params.newValue);
}
export function formatNumber(number ) {
  if (!number)
    return "0";
  return Math.round(number)
    .toString()
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
}



// WEBPACK FOOTER //
// ./src/providers/util-general/util-general.ts